import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const ActivityIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M9 2c.4 0 .8.3 1 .7l5 15.1 2-6.1a1 1 0 0 1 1-.7h4a1 1 0 0 1 0 2h-3.3L16 21.3a1 1 0 0 1-1.8 0L9 6.2l-2 6.1a1 1 0 0 1-1 .7H2a1 1 0 1 1 0-2h3.3L8 2.7A1 1 0 0 1 9 2Z"
        clipRule="evenodd"
      />
    </Icon>
  )
);
export default ActivityIcon;
